/* eslint-disable */
import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import "../../Assets/css/custom_datepicker.css";

const CustomDatepicker = ({
  startDate,
  endDate,
  onChange,
  maxDate = new Date(),
  showWrapperStyles = true,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  // close when range is complete (works even if parent updates dateRange)
  useEffect(() => {
    if (startDate && endDate) setIsOpen(false);
  }, [startDate, endDate]);

  return (
    <div
      className={`d-flex align-items-center ${
        showWrapperStyles ? "bg-white shadow-sm px-3 py-2" : ""
      }`}
      style={{
        position: "relative",
        borderRadius: showWrapperStyles ? "10px" : undefined,
        height: showWrapperStyles ? "4.2rem" : undefined,
        width: "fit-content",
      }}
      onClick={() => setIsOpen(true)} // click anywhere opens
    >
      <div className="me-3">
        <CalendarMonthIcon sx={{ fontSize: 30 }} className="text-navy w-full" />
      </div>

      <DatePicker
        selectsRange
        startDate={startDate}
        endDate={endDate}
        open={isOpen}
        onClickOutside={() => setIsOpen(false)}
        onChange={(dates) => {
          onChange(dates);
          const [s, e] = dates || [];
          if (s && e) setIsOpen(false); // ✅ close immediately after end date
        }}
        shouldCloseOnSelect={false} // we control closing ourselves
        isClearable
        onCalendarClose={() => setIsOpen(false)}
        monthsShown={2}
        maxDate={maxDate}
        dateFormat="dd/MM/yyyy"
        className="date_picker_custom_new"
        popperClassName="regular-picker-popper"
        showYearDropdown
        scrollableYearDropdown
        yearDropdownItemNumber={100}
      />
    </div>
  );
};

export default CustomDatepicker;
